import React from 'react';

import { baseURL } from 'src/config';
import './footer.css';

export default class Footer extends React.Component {
  render() {
    return (
      <footer className="page-footer">
        <div className="page-footer-body">© 2018 Playerbase, Inc. All rights reserved.</div>
        <div style={{ flex: 1 }} />
        <a className="page-footer-link" href={`${baseURL}/privacy`}>
          Privacy
        </a>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.js